import {observer} from 'mobx-react-lite';
import React from 'react';
import {LIVE_CHAT_WIDGET_ID, LIVE_CHAT_WIDGET_LOADER_URL} from '../config';
import useStore from '../stores/useStore';

const LiveChatWidget: React.FC = observer(() => {
  const {workspaces, userStore} = useStore();

  React.useEffect(() => {
    if (!LIVE_CHAT_WIDGET_ID || !LIVE_CHAT_WIDGET_LOADER_URL) {
      return;
    }

    if (window.owcWidget && !workspaces.isInit && !userStore.isLoggedIn) {
      window.owcWidget.set('system.enable');
    } else if (window.owcWidget && workspaces.isInit && userStore.isLoggedIn) {
      window.owcWidget.set('system.disable');
    }

    if (window.owcWidget || !userStore.isInit || (workspaces.isInit && userStore.isLoggedIn)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = LIVE_CHAT_WIDGET_LOADER_URL + LIVE_CHAT_WIDGET_ID;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    const owcWidget = function () {} as any;
    owcWidget.configure = function (i: string, j: any) {
      owcWidget.c[i] = j;
    };
    owcWidget.set = function () {
      // eslint-disable-next-line prefer-rest-params
      owcWidget.s.push(arguments);
    };
    owcWidget.c = {};
    owcWidget.s = [];
    window.owcWidget = owcWidget;
  }, [userStore.isInit, workspaces.isInit, userStore.isLoggedIn]);

  return null;
});

LiveChatWidget.displayName = 'LiveChatWidget';

export default LiveChatWidget;
